import { IonItem, IonLabel } from '@ionic/react';
import { CheckmarkIcon, CopyIcon } from '../../components/icons/Icons.tsx';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { TrackingService } from '../../support/tracking/TrackingService.ts';
import { useClipboard } from '../../support/hooks/useClipboard.tsx';
import { ToggleLatLngFormatPreferenceButton } from '../../map/components/ToggleLatLngFormatPreferenceButton.tsx';
import { LatLngFormatPreferenceProvider } from '../../map/LatLngFormatPreferenceProvider.ts';
import { useSubscription } from '@meraki-internal/state';
import { ICoordinate } from '../../support/model/ICoordinate.ts';

export const LatLngIonItem: React.FC<{location: ICoordinate, trackingFrom: string}> = ( { location, trackingFrom }) => {
    const [copyToClipboard, justCopied] = useClipboard();
    const tracker = useInstance(TrackingService);

    const latLngFormatPreferenceProvider = useInstance(LatLngFormatPreferenceProvider);
    useSubscription(() => latLngFormatPreferenceProvider);

    const value = latLngFormatPreferenceProvider.getFormattedLatLng(location);

    return (
        <IonItem button detail={false} onClick={() => {
            tracker.trackWithDebounce('Mission Details | Copy Lat Lng');

            copyToClipboard({ value });
        }}>
            <IonLabel>
                <h2>Lat / Lng</h2>
                <p>{value}</p>
            </IonLabel>
            <div slot="end" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                <div style={{ marginRight: 10 }}>
                    <ToggleLatLngFormatPreferenceButton trackingFrom={trackingFrom} />
                </div>
                {!justCopied && (
                    <CopyIcon color="medium" size="medium" />
                )}
                {justCopied && (
                    <CheckmarkIcon color="success" size="medium" />
                )}
            </div>

        </IonItem>
    );
};
